import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Unprotected } from '@auth-util-lib/auth.model'
import { AppRoute } from '@auth-util-lib/routing.model'
import { UpdatesComponent } from '@platform-lib/updates/updates.component'

const routes: AppRoute[] = [
    {
        component: UpdatesComponent,
        data: {
            breadcrumb: {
                name: 'traigo Updates',
                url: '/traigo-updates',
            },
            protection: Unprotected,
        },
        path: '',
    },
]

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)],
})
export class UpdatesRoutingModule {}
